import React from 'react'
import TagCloud from 'react3dtagcloud'

// 文献图谱-搜索词词云
export default function DataQuery() {
  const tagName = [ '性别', '年龄', '民族', '教育程度', '体格检查', '身高', '体重', '症状', '咳嗽', '咯痰', '呼吸困难', '喘息', '鼻塞', '发热', '疾病史', '呼吸系统疾病', '肺炎', '肺栓塞', '肺炎', '肺栓塞', '肺癌', '心血管系统', '高血压', '冠心病', '房颤', '内分泌及代谢系统', '糖尿病', '骨质疏松', '消化系统', '胃食道反流病', '消化性溃疡', '肝硬化', '个人史', '吸烟', '饮酒', '慢阻肺急性加重史', '治疗', '用药', '辅助检查', '肺功能', '血常规', '心电图', '血气分析', '心脏彩超', '肺通气 灌注显像' ]
  return(
    <div style={{ width: '75%' }}>
      <TagCloud tagName={ tagName } radius={150} />
    </div>
  )
}
